import { createAction } from 'redux-actions';
import axios from 'axios';
import routes from '../routes';

export const signupUser = createAction('SIGNUP_USER');

export const toggleLoginModal = createAction('TOGGLE_USER_MODAL');
export const toggleRegistrationModal = createAction('TOGGLE_REGISTRATION_MODAL');

export const updateLogin = createAction('UPDATE_LOGIN');
export const updatePassword = createAction('UPDATE_PASSWORD');

export const updateRegEmail = createAction('UPDATE_REG_EMAIL');
export const updateRegPassword = createAction('UPDATE_REG_PASSWORD');
export const updateRegPasswordAgain = createAction('UPDATE_REG_PASSWORD_AGAIN');

export const userLoginRequest = createAction('USER_LOGIN_REQUEST');
export const userLoginSuccess = createAction('USER_LOGIN_SUCCESS');
export const userLoginFailure = createAction('USER_LOGIN_FAILURE');

export const userLogoutRequest = createAction('USER_LOGOUT_REQUEST');
export const userLogoutSuccess = createAction('USER_LOGOUT_SUCCESS');
export const userLogoutFailure = createAction('USER_LOGOUT_FAILURE');

export const userRegistrationRequest = createAction('USER_REGISTRATION_REQUEST');
export const userRegistrationSuccess = createAction('USER_REGISTRATION_SUCCESS');
export const userRegistrationFailure = createAction('USER_REGISTRATION_FAILURE');

export const loginUser = loginUserData => async (dispatch) => {
  dispatch(userLoginRequest());
  try {
    const response = await axios.post(routes.loginUser(), loginUserData, {withCredentials: true});

    if (response.data.status === 0) {
      dispatch(userLoginFailure({message: response.data.message}));
    } else if (response.data.status === 1) {
      const user = {
        id: response.data.id,
        login: response.data.username,
        userWords: response.data.userWords,
		activity: response.data.activity,
      };

      dispatch(userLoginSuccess({ user }));
    } else {
      dispatch(userLoginFailure({message: 'error!'}));
    }
  } catch (e) {
    dispatch(userLoginFailure({message: 'Network error!'}));
  }
};

export const registrationUser = registrationUserData => async (dispatch) => {
  dispatch(userRegistrationRequest());
  try {
    const response = await axios.post(routes.registrationtUser(), registrationUserData, {withCredentials: true});

    if (response.data.status === 0) {
      dispatch(userRegistrationFailure({ message: response.data.message }));
    } else if (response.data.status === 1) {
      const user = {
        id: response.data.id,
        login: response.data.username,
        userWords: response.data.userWords,
		activity: response.data.activity,
      };

      dispatch(userRegistrationSuccess({ user }));
    } else {
      dispatch(userRegistrationFailure({ message: 'error!' }));
    }
  } catch (e) {
    dispatch(userRegistrationFailure({ message: 'Network error!' }));
  }
};

export const getProfile = () => async (dispatch) => {
  dispatch(userLoginRequest());
  try {
    const response = await axios.get(routes.profile(), {withCredentials: true});

    if (response.data.status === 0) {
      dispatch(userLoginFailure({message: response.data.message}));
    } else if (response.data.status === 1) {
      const user = {
        id: response.data.id,
        login: response.data.username,
        userWords: response.data.userWords,
		activity: response.data.activity,
      };

      dispatch(userLoginSuccess({ user }));
    } else {
      dispatch(userLoginFailure({message: ''}));
    }
  } catch (e) {
    dispatch(userLoginFailure({message: 'Network error!'}));
  }
};

export const logoutUser = loginUserData => async (dispatch) => {
  dispatch(userLogoutRequest());
  try {
    const response = await axios.get(routes.logoutUser(), {withCredentials: true});

    if (response.data.status === 0) {
      dispatch(userLoginFailure({message: response.data.message}));
    } else if (response.data.status === 1) {
      dispatch(userLogoutSuccess());
    } else {
      dispatch(userLogoutFailure({message: 'error!'}));
    }
  } catch (e) {
    dispatch(userLogoutFailure({message: 'Network error!'}));
  }
};

export const updateSourceText = createAction('UPDATE_SOURCE_TEXT');
export const toggleSourceTextModal = createAction('TOGGLE_SOURCE_TEXT_MODAL');


export const sendSourceTextRequest = createAction('SEND_SOURCE_TEXT_REQUEST');
export const sendSourceTextSuccess = createAction('SEND_SOURCE_TEXT_SUCCESS');
export const sendSourceTextFailure = createAction('SEND_SOURCE_TEXT_FAILURE');

export const sendSourceText = sourceText => async (dispatch) => {
  dispatch(sendSourceTextRequest());
  try {
    const response = await axios.post(routes.sourceText(), sourceText, {withCredentials: true});
    if (response.data.status === 0) {
      dispatch(sendSourceTextFailure({message: response.data.message}));
    } else if (response.data.status === 1) {
      dispatch(sendSourceTextSuccess({wordsForAdd: response.data.baseForm}));
    } else if (response.data.status === 3) {
      dispatch(userLoginFailure({message: ''}));
    } else {
      dispatch(sendSourceTextFailure({message: 'error!'}));
    }
  } catch (e) {
    dispatch(sendSourceTextFailure({message: 'Network error!'}));
  }
};

export const addUserWordsRequest = createAction('ADD_USER_WORDS_REQUEST');
export const addUserWordsSuccess = createAction('ADD_USER_WORDS_SUCCESS');
export const addUserWordsFailure = createAction('ADD_USER_WORDS_FAILURE');

export const checkUserWords = createAction('CHECK_USER_WORDS');

export const addUserWords = userWordsIds => async (dispatch) => {
  dispatch(addUserWordsRequest());
  try {
    const response = await axios.post(routes.addUserWords(), userWordsIds, {withCredentials: true});
    if (response.data.status === 0) {
      dispatch(addUserWordsFailure({message: response.data.message}));
    } else if (response.data.status === 1) {
      dispatch(addUserWordsSuccess({userWords: response.data.userWords, activity: response.data.activity,}));
    } else if (response.data.status === 3) {
      dispatch(userLoginFailure({message: ''}));
    } else {
      dispatch(addUserWordsFailure({message: 'error!'}));
    }
  } catch (e) {
    dispatch(addUserWordsFailure({message: 'Network error!'}));
  }
};

export const toggleStudyWordsModal = createAction('TOGGLE_STUDY_WORDS_MODAL');

export const getUserWordsRequest = createAction('GET_USER_WORDS_REQUEST');
export const getUserWordsSuccess = createAction('GET_USER_WORDS_SUCCESS');
export const getUserWordsFailure = createAction('GET_USER_WORDS_FAILURE');

// Сохраняет "Я знаю это слово"
export const setWordStudied = (curUserWords, oldStudyTask, studied) => async (dispatch) => {
	const data = {studied, userWordId: oldStudyTask.userWordId};
	axios.put(routes.userWordsStudied(), data, {withCredentials: true}).then(
	  response => {
		if (response.data.status === 3) {
		  dispatch(userLoginFailure({message: ''}));
		}
	  }
	);

	curUserWords = curUserWords.map(
	  word => word.userWordId === data.userWordId ? {...word, studied} : word
	);

	const studyTask = getStudyTask(curUserWords);

	dispatch(getUserWordsSuccess({userWords: curUserWords, studyTask}));
};

export const getUserWords = (curUserWords, oldStudyTask, isCorrect) => async (dispatch, getState) => {
  let countActivity = 0;

  if(oldStudyTask !== undefined) {
    let newScore = oldStudyTask.score;

    if(isCorrect) {
      newScore += 10;
      countActivity++;
    } else {
      newScore = newScore - 15 >= 0 ? newScore - 20 : 0;
    }

    const data = {score: newScore, userWordId: oldStudyTask.userWordId};
    axios.put(routes.updateUserWords(), data, {withCredentials: true}).then(
      response => {
        if (response.data.status === 3) {
          dispatch(userLoginFailure({message: ''}));
        }
      }
    );

    curUserWords = curUserWords.map(
      word => word.userWordId === data.userWordId ? {...word, score: data.score} : word
    );
  }

  const repeatWordId = oldStudyTask && !isCorrect ? oldStudyTask.userWordId : undefined;
  const studyTask = getStudyTask(curUserWords, repeatWordId);

  const curDate = new Date();
  curDate.setUTCHours(0, 0, 0, 0);
  const curDateString = curDate.toISOString().substring(0,10);

  let activityIsUpdated = false;
  let activity = getState().studyWords.activity.map(
      a => {
        if (curDateString === a.date.substring(0,10)) {
          activityIsUpdated = true;
          return {...a, countPractice: a.countPractice + countActivity};
        }

        return a;
      }
  );

  if (!activityIsUpdated) {
    activity = [ ...activity, {date: curDate.toISOString(), countPractice: countActivity, countNewWords: 0} ];
  }

  dispatch(getUserWordsSuccess({userWords: curUserWords, studyTask, activity}));
};


const getStudyTask = (userWords, repeatWordId) => {
  let word;
  let variantsTranslte;
  let indexesUsed;

  const words = userWords
      .filter(w => !w.studied)
      .sort(() => Math.random() - 0.5)
      .sort((w1, w2) => {
        if (w1.score < w2.score) {
          return -1;
        }
        if (w1.score > w2.score) {
          return 1;
        }

        return 0;
      });

  if (repeatWordId) {
    let index;
    const wordData = words.find((e, i) => {
      if (repeatWordId === e.userWordId) {
        index = i;
        return true;
      }

      return false;
    });

    word = {
      value: wordData.wordValue,
      forms: wordData.wordForms,
      userWordId: wordData.userWordId,
      score: wordData.score,
      isAnswerClicked: false,
    };

    variantsTranslte = [
      {translate: wordData.wordTranslate, isCorrect: true, isClicked: false},
    ];

    indexesUsed = [index];
  } else {
    const maxIndex = 20;
    const maxRandomIndex = words.length < maxIndex ? words.length : maxIndex;
    const randomIndex = Math.floor(Math.random() * maxRandomIndex);
    indexesUsed = [randomIndex];

    word = {
      value: words[randomIndex].wordValue,
      forms: words[randomIndex].wordForms,
      userWordId: words[randomIndex].userWordId,
      score: words[randomIndex].score,
      isAnswerClicked: false,
    };

    variantsTranslte = [
      {translate: words[randomIndex].wordTranslate, isCorrect: true, isClicked: false},
    ];
  }

  let randVariantIndex = Math.floor( Math.random() * words.length);
  while (indexesUsed.indexOf(randVariantIndex) !== -1) {
    randVariantIndex = Math.floor( Math.random() * words.length );
  }
  indexesUsed.push(randVariantIndex);
  variantsTranslte.push(
    {translate: words[randVariantIndex].wordTranslate, isCorrect: false, isClicked: false}
  );

  while (indexesUsed.indexOf(randVariantIndex) !== -1) {
    randVariantIndex = Math.floor( Math.random() * words.length );
  }
  indexesUsed.push(randVariantIndex);
  variantsTranslte.push(
    {translate: words[randVariantIndex].wordTranslate, isCorrect: false, isClicked: false}
  );

  while (indexesUsed.indexOf(randVariantIndex) !== -1) {
    randVariantIndex = Math.floor( Math.random() * words.length );
  }
  indexesUsed.push(randVariantIndex);
  variantsTranslte.push(
    {translate: words[randVariantIndex].wordTranslate, isCorrect: false, isClicked: false}
  );

  variantsTranslte = variantsTranslte.sort( () => 0.5 - Math.random() );

  return {...word, variantsTranslte};
};

export const handleStudyAnswer = createAction('HANDLE_STUDY_ANSWER');
export const updateUserWordScore = createAction('UPDATE_USER_WORD_SCORE');

export const hideMessage = createAction('HIDE_MESSAGE');
export const hideMessageUserWordsManage = createAction('HIDE_MESSAGE_USER_WORDS_MANAGE');

export const toggleUserWordsManageModal = createAction('TOGGLE_USER_WORDS_MANAGE_MODAL');
export const userWordsManageSetPagination = createAction('USER_WORDS_MANAGE_SET_PAGINATION');
export const userWordsManageCheckWord = createAction('USER_WORDS_MANAGE_CHECK_WORD');



export const deleteUserWordsRequest = createAction('DELETE_USER_WORDS_REQUEST');
export const deleteUserWordsSuccess = createAction('DELETE_USER_WORDS_SUCCESS');
export const deleteUserWordsFailure = createAction('DELETE_USER_WORDS_FAILURE');

export const deleteUserWords = (userWordsIds) => async (dispatch) => {
  if(userWordsIds.length === 0) {
    dispatch(deleteUserWordsSuccess([]));
  }

  dispatch(deleteUserWordsRequest());
  try {
    const response = await axios.post(routes.deleteUserWords(), { userWordsIds }, {withCredentials: true});
    if (response.data.status === 0) {
      dispatch(deleteUserWordsFailure({message: response.data.message}));
    } else if (response.data.status === 1) {
      dispatch(deleteUserWordsSuccess({userWordsIds, message: response.data.message}));
    } else if (response.data.status === 3) {
      dispatch(userLoginFailure({message: ''}));
    } else {
      dispatch(deleteUserWordsFailure({message: 'Не удалось удалить выбранные слова.'}));
    }
  } catch (e) {
    dispatch(deleteUserWordsFailure({message: 'Не удалось удалить выбранные слова. Ошибка сети!'}));
  }
};

export const turnSound = createAction('TURN_SOUND');


export const playAudio = () => (dispatch, getState) => {
  const state = getState();

  if (state.studyWords.currentAudio) {
    state.studyWords.currentAudio.play();
  }
};



// WEBPACK FOOTER //
// ./src/actions/index.js